import PeriodosService from "../../../../app/modules/cursos/periodo/service/PeriodoService"
import coursesService from "../../../../app/modules/cursos/service/coursesService"
import debtsService from "../../../../app/modules/debitos/service/debtsService"
import associatesService from "../../../../app/modules/associados/service/associatesService"
import processosService from "../../../../app/modules/processos/components/service/processosService"

 
export async function getBreadcrumbName(pathname: string): Promise<string | null> {
  const parts = pathname.split('/').filter(Boolean)

  if (pathname.includes('/cursos/editar/') && parts.length >= 3) {
    const id = parseInt(parts[2])
    if (!isNaN(id)) {
      const curso = await coursesService.getCourseById(id)
      return curso?.curso?.nome || 'Curso desconhecido'
    }
  }
  
  if (pathname.startsWith('/cursos/') && parts.length === 2) {
    const id = parseInt(parts[1])
    if (!isNaN(id)) {
      const curso = await coursesService.getCourseById(id)
      return curso?.curso?.nome || 'Curso desconhecido'
    }
  }
  

  if (pathname.includes('/cursos/periodos/editar/') && parts.length >= 4) {
    const id = parseInt(parts[3])
    if (!isNaN(id)) {
      const periodo = await PeriodosService.getPeriodById(id)
      return periodo?.descricao || 'Período desconhecido'
    }
  }

  if (pathname.startsWith('/cursos/periodos/') && parts.length === 3) {
    const id = parseInt(parts[2])
    if (!isNaN(id)) {
      const periodo = await PeriodosService.getPeriodById(id)
      return periodo?.descricao || 'Período desconhecido'
    }
  }

    if (pathname.startsWith('/tratamentos/') && parts.length >= 2) {
        const id = parseInt(parts[1])
        if (!isNaN(id)) {
        return 'Tratamentos do Associado'
        }
    }

    if (pathname.includes('/associados/editar/') && parts.length >= 3) {
        const id = parseInt(parts[2])
        if (!isNaN(id)) {
            try {
                const associado = await associatesService.getAssociadoById(id)
                return associado?.nome || 'Associado desconhecido'
            } catch (error) {
                console.error('Erro ao buscar associado:', error)
                return 'Associado desconhecido'
            }
        }
    }

    if (pathname.includes('/processos/novo') && parts.length === 2 && parts[1] === 'novo') {
        return 'Novo Processo'
    }

    if (pathname.startsWith('/processos/') && parts.length === 2 && parts[1] !== 'novo') {
        const id = parseInt(parts[1])
        if (!isNaN(id)) {
            try {
                const processo = await processosService.getProcessoById(id)
                return processo?.numeroProcesso || processo?.nomeParticipante || 'Processo desconhecido'
            } catch (error) {
                console.error('Erro ao buscar processo:', error)
                return 'Processo desconhecido'
            }
        }
    }
  

  return null
}
